module.exports = __webpack_public_path__ + "media/images/camera-0cc3a00d88696a639d6f81da3bed0c5e.png";